/**
 * @file src/shell/i18n/vi.js
 * Chuỗi của SHELL (taskbar, cài đặt, lỗi, loading). Dùng chung MỌI tiết.
 * boot.js trộn: { ...SHELL_VI, ...dict của tiết } — tiết ghi đè được nếu cần.
 * Tiết KHÔNG khai lại các key này trong i18n/vi.json của mình.
 */
export const SHELL_VI = {
  // ----- Nút thanh dưới -----
  // NGẮN GỌN: mỗi nút hiện chữ NGAY DƯỚI icon trong một ô hẹp (~64px), chuỗi dài
  // sẽ phá layout. Đây cũng là tooltip nên đừng viết thành câu.
  'btn.rotate': 'Xoay',
  'btn.labels': 'Nhãn',
  'btn.sound': 'Âm thanh',
  'btn.info': 'Thông tin',
  'btn.settings': 'Cài đặt',

  // ----- Chỉ báo zoom (hai cột bậc hai bên mô hình) -----
  'zoom.label': 'Phóng to / thu nhỏ',

  // ----- Header (thanh trên cùng) -----
  'header.back': 'Thoát',
  'header.pen': 'Bút',
  'header.whiteboard': 'Bảng trắng',
  'header.exercise': 'Bài tập',

  // ----- Lớp vẽ tự do (PenLayer, bật bởi nút "Bút") -----
  'pen.palette': 'Bảng chọn màu bút',
  'pen.clear': 'Xoá',

  // ----- Bảng trắng (Whiteboard, bật bởi nút "Bảng trắng") -----
  'wb.close': 'Đóng bảng trắng',
  'wb.undo': 'Lùi lại',
  'wb.redo': 'Làm lại',
  'wb.save': 'Lưu ảnh',

  // ----- Bài tập (ExercisePanel, bật bởi nút "Bài tập") -----
  // Đây là TEMPLATE trắc nghiệm chung — không biết nội dung câu hỏi, xem đầu
  // ExercisePanel.js. Chuỗi ở đây chỉ là khung UI (nút điều hướng, trạng thái tải).
  'quiz.close': 'Đóng bài tập',
  'quiz.prev': 'Trước',
  'quiz.next': 'Sau',
  'quiz.answer': 'Đáp án',
  'quiz.progress': 'Câu {n}/{total} · {section}',
  'quiz.loading': 'Đang tải câu hỏi…',
  'quiz.empty': 'Chưa có bài tập cho tiết này.',
  'quiz.error': 'Không tải được câu hỏi.',
  'quiz.retry': 'Thử lại',

  // ----- Panel thông tin -----
  'info.panelTitle': 'Thông tin bài giảng',
  'info.objectives': 'Mục tiêu bài học',

  // ----- Cài đặt -----
  'set.title': 'Cài đặt',
  // Nhãn NHÓM (hiện chữ HOA nhỏ qua CSS text-transform, xem shell.css) — tách bảng
  // cài đặt thành 3 khối theo file thiết kế, thay vì một danh sách phẳng.
  'set.section.sound': 'Âm thanh',
  'set.section.display': 'Hiển thị',
  'set.section.motion': 'Chuyển động',
  'set.sound': 'Âm thanh',
  'set.volume': 'Âm lượng',
  'set.language': 'Ngôn ngữ',
  'set.background': 'Màu nền',
  'set.bgDark': 'Nền đen',
  'set.bgLight': 'Nền sáng',
  'set.bgCustom': 'Chọn màu khác',
  'set.rotate': 'Xoay',
  'set.reducedMotion': 'Giảm chuyển động',
  'anim.play': 'Phát',
  'anim.pause': 'Tạm dừng',
  'set.motionSpeed': 'Tốc độ chuyển động',
  'set.on': 'Bật',
  'set.off': 'Tắt',
  'lang.vi': 'Tiếng Việt',
  'lang.en': 'English',

  // ----- Loading -----
  'loading.subtitle': 'Đang tải mô hình và dữ liệu…',
  'loading.assets': 'Đang tải tài nguyên…',
  'loading.done': 'Hoàn tất, đang vào bài học…',

  // ----- Lỗi (khớp bộ error code của bridge) -----
  'err.webglUnsupported':
    'Thiết bị hoặc trình duyệt của em chưa hỗ trợ đồ hoạ 3D. Em vẫn có thể đọc nội dung bài học bên dưới.',
  'err.contextLost': 'Đang khôi phục hình ảnh 3D…',
  'err.coreLoadFailed': 'Không tải được bài giảng. Em thử tải lại trang nhé.',
  'err.assetFailed': 'Một tài nguyên của bài học chưa tải được.',
  'err.initFailed': 'Không mở được bài giảng.',
  'err.runtime': 'Bài giảng gặp sự cố. Em thử tải lại trang nhé.',
  'err.retry': 'Thử lại',
};
